import React from "react";

const NavigationContext = React.createContext('BookStore');

export default NavigationContext;